import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";
import { CloneOrMoveResourceType, InvokerType } from "../clone-or-move.types";

export type ConfirmCloneOrMoveComponentData = {
  invokerType: InvokerType;
};
@Component({
  selector: "confirm-clone-or-move",
  templateUrl: "./confirm-clone-or-move.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCloneOrMoveComponent implements OnInit {
  constructor(private modalRef: UiModalRef, @Inject(UI_MODAL_DATA) modalData: ConfirmCloneOrMoveComponentData) {
    Object.assign(this, modalData);
  }

  private invokerType: InvokerType;
  public isInvokerTypeOKR: boolean;

  public ngOnInit(): void {
    this.isInvokerTypeOKR = this.invokerType == CloneOrMoveResourceType.Objective;
  }

  public destroyModal(): void {
    this.modalRef.destroy();
  }

  public confirm(): void {
    this.modalRef.destroy(true);
  }
}
